import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateGroupMember = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Group Member'
      fields={fields}
      apiPath='admin/group_users'
      successRedirectPath={resource => `/write-now/members/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateGroupMember
